import * as React from 'react';

import { SelfStorage__Promotion } from '@admin/schema';

export const Summary: React.FC<{
  promotion: Pick<SelfStorage__Promotion, 'name'>;
}> = ({ promotion: { name } }) => <>{name}</>;
